import React from 'react'
import Button from 'components/Button'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import NumbersAvailableTable from '../NumbersAvailableTable'

export default props => {
  const { prev, change, formData, numberType, submit } = props
  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        Search for and select the {numberType} number you wish to activate.
      </div>
      <NumbersAvailableTable
        country="AU"
        type={numberType}
        formData={formData}
        onSelect={service => {
          change('number', service.phoneNumber)
          submit()
        }}
      />
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button plain onClick={prev}>
          Back
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTwilioSelectNewNumberStep/NumbersTwilioSelectNewNumberStep.jsx